import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { identities } from '../data/identities';
import { useAppState } from '../hooks/useAppState';
import { IdentityCard } from '../components/IdentityCard';

const easeOut = [0.22, 1, 0.36, 1] as const;

export function IdentityPage(): JSX.Element {
  const { selectIdentity, navigate, state } = useAppState();
  const [localSelectedId, setLocalSelectedId] = useState<string | null>(state.selectedIdentity);

  const handleSelect = (id: string) => {
    setLocalSelectedId(id);
    selectIdentity(id as import('../types').IdentityId);
  };

  const selectedIdentity = identities.find((i) => i.id === localSelectedId);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: '32px 20px',
        gap: '40px',
        backgroundColor: '#f5f5f7',
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px' }}>
        <h1
          style={{
            fontSize: '24px',
            fontWeight: 500,
            textAlign: 'center',
            color: '#1a1a1c',
            margin: 0,
            letterSpacing: '0.04em',
          }}
        >
          你是谁？
        </h1>
        <p
          style={{
            fontSize: '14px',
            color: '#a1a1a6',
            margin: 0,
            letterSpacing: '0.02em',
          }}
        >
          选择你的职业身份，获取专属场景
        </p>
      </div>

      <div
        className="no-scrollbar"
        style={{
          display: 'flex',
          gap: '12px',
          overflowX: 'auto',
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
          width: '100%',
          padding: '16px 0',
          scrollSnapType: 'x mandatory',
          WebkitOverflowScrolling: 'touch',
        }}
      >
        {identities.map((identity) => (
          <IdentityCard
            key={identity.id}
            identity={identity}
            isSelected={localSelectedId === identity.id}
            onClick={() => handleSelect(identity.id)}
          />
        ))}
      </div>

      <AnimatePresence>
        {selectedIdentity && (
          <motion.div
            key={selectedIdentity.id}
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 16 }}
            transition={{ duration: 0.35, ease: easeOut }}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '28px',
              width: '100%',
              maxWidth: '320px',
            }}
          >
            <div
              style={{
                padding: '16px 20px',
                borderRadius: '12px',
                backgroundColor: '#ffffff',
                border: '1px solid rgba(0, 0, 0, 0.06)',
                boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                width: '100%',
                boxSizing: 'border-box',
              }}
            >
              <p
                style={{
                  fontSize: '14px',
                  color: '#6e6e73',
                  textAlign: 'center',
                  margin: 0,
                  lineHeight: 1.6,
                  fontStyle: 'italic',
                }}
              >
                "{selectedIdentity.painPoint}"
              </p>
            </div>

            <motion.button
              onClick={() => navigate('sceneFlow')}
              whileTap={{ scale: 0.97 }}
              style={{
                padding: '14px 32px',
                borderRadius: '12px',
                backgroundColor: '#1a1a1c',
                color: '#ffffff',
                fontSize: '14px',
                fontWeight: 600,
                border: 'none',
                cursor: 'pointer',
                width: '100%',
                letterSpacing: '0.02em',
                WebkitTapHighlightColor: 'transparent',
                transition: 'all 0.3s cubic-bezier(0.22, 1, 0.36, 1)',
              }}
            >
              看看我的 AI 玩法
            </motion.button>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
